module.exports = __webpack_public_path__ + "img/kele3.d06c2453.jpg";